/**
 * Docs APIクライアント
 * ドキュメント関連のAPI呼び出しを管理
 */

import { apiGet } from './client';
import type { DocContent, DocTreeNode } from '@/lib/types';

/**
 * ドキュメントツリーを取得
 */
export async function getDocsTree(authHeaders?: Record<string, string>): Promise<DocTreeNode[]> {
  return apiGet<DocTreeNode[]>('/docs/all', authHeaders);
}

/**
 * ドキュメント内容を取得
 *
 * @param path - docs/以下の相対パス（例: "feature/stock-optimization.md"）
 */
export async function getDocContent(
  path: string,
  authHeaders?: Record<string, string>,
): Promise<DocContent> {
  const encodedPath = encodeURIComponent(path);
  return apiGet<DocContent>(`/docs/get?path=${encodedPath}`, authHeaders);
}
